import { I515Form } from 'clickNgo/models/crud/forms'

import { ProfilingCodeOptions } from '../model/types'

import { mapProfilingCode } from './mapProfilingCode'

export const mapProfilingCodeOptions = (data: I515Form[]): ProfilingCodeOptions => {
  return data.reduce<ProfilingCodeOptions>((acc, item) => {
    const profilingCode = mapProfilingCode(item)

    if (!acc[profilingCode.type]) {
      acc[profilingCode.type] = []
    }

    acc[profilingCode.type].push(profilingCode)

    return acc
  }, {} as ProfilingCodeOptions)
}
